module.exports = __webpack_public_path__ + "static/media/press28.93ed752c.jpg";